export enum DataHook {
  Logo = 'editorx-header-logo-link',
  UserMenu = 'userMenu',
  MenuToggle = 'editorx-header-menu-toggle',
  NavigationMenu = 'editorx-header-navigation-menu',
  FooterDescription = 'editorx-footer-description',
  FooterMenu = 'editorx-footer-menu',
}
